import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

const UIModalExit = ({ ...children }) => (
  <Dialog
    open={children.open}
    onClose={children.toggleDialog}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    <DialogTitle id="alert-dialog-slide-title">
      Deseja sair do sistema?
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        Vamos sentir sua falta, mas obrigado por vir ;)
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={children.toggleDialog} color="primary">
        Cancelar
      </Button>
      <Button onClick={children.exit} color="primary">
        Sair
      </Button>
    </DialogActions>
  </Dialog>
);

export default UIModalExit;
